import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";
import { message } from 'antd';

// load -------------------------------------------------------------
const get = async () => {
    return await axios({
        url: getmainurl() + '/api/v1/settings/', method: 'get', headers: authHeader(), data: 1
    }).catch(function (error) {
        console.log(error.response?.data);
    })
}

// save -------------------------------------------------------------
const save = async (data) => {
    return await axios({
        url: getmainurl() + '/api/v1/settings/', method: 'post', headers: authHeader(), data: data
    }).catch(function (error) {
        console.log(error.response?.data);
    })
}

/* -------------------------------------------------------------------------------- *\
|                               setDebug
\* -------------------------------------------------------------------------------- */
const setDebug = async (active) =>
{
    return await axios({ url: getmainurl() + '/api/v1/settings/debug/' + (active ? 'active' : 'notactive'), method: 'get', headers: authHeader() })
        .catch(function (error) { message.warning(error.response?.data); })
}
/* -------------------------------------------------------------------------------- *\
|                               getDebug
\* -------------------------------------------------------------------------------- */
const getDebug = async () =>
{
    return await axios({ url: getmainurl() + '/api/v1/settings/debugmode', method: 'get', headers: authHeader() })
        .then(response => response.data)
        .catch(function (error) { message.warning(error.response?.data); })
}
/* -------------------------------------------------------------------------------- *\
|                               getLogs
\* -------------------------------------------------------------------------------- */
const getLogs = async (log, nbline) =>
{
    return axios({ url: getmainurl() + '/api/v1/settings/logs/' + log + "/" + nbline, method: 'get', headers: authHeader() })
        .then(response => response.data)
}

// default export ---------------------------------------------------
const settings = {
    get,
    save,
    setDebug,
    getDebug,
    getLogs
};

export default settings;